<template>
  <article class="feature-page">
    <div class="max-w-4xl mx-auto px-4 py-10">
      <h2 class="text-2xl lg:text-3xl font-bold text-center mb-4">
        piceditor.io Compress Image: Optimize Photos with Smart Compression
      </h2>
      <p class="text-xl text-center mb-6">
        Automatically reduce image sizes while preserving quality, with optional WebP conversion for even better
        performance.
      </p>

      <p class="mb-4">
        Our Compress Image tool intelligently calculates the optimal compression level for each image, ensuring the best
        balance between file size and visual quality. No manual tweaking needed. For maximum efficiency, you can also
        convert images to WebP format in a single click.
      </p>

      <h3 class="text-2xl font-bold mt-12 mb-6">Why Use Compress Image?</h3>
      <div class="grid grid-cols-1 md:grid-cols-3 gap-8 feature-page__specific">
        <div class="flex flex-col space-y-4 items-center text-center">
          <img src="@/images/landing_pages/efficiency.png" alt="Smart Compression" />
          <strong>Smart Compression</strong>
          <p>
            Our algorithm automatically chooses the best compression settings, so you don't have to adjust anything
            manually.
          </p>
        </div>

        <div class="flex flex-col space-y-4 items-center text-center">
          <img src="@/images/landing_pages/quality.png" alt="WebP Conversion" />
          <strong>WebP Conversion</strong>
          <p>
            Convert images to modern WebP format for better quality at smaller file sizes, perfect for websites and
            apps.
          </p>
        </div>

        <div class="flex flex-col space-y-4 items-center text-center">
          <img src="@/images/landing_pages/speed.png" alt="Fast & Easy" />
          <strong>Fast & Easy</strong>
          <p>Compress and convert in seconds with no technical skills required. Simple, quick, and efficient.</p>
        </div>
      </div>

      <h3 class="text-2xl font-bold mt-12 mb-6">How It Works</h3>
      <ol class="list-decimal pl-5 mb-6">
        <li><strong>Upload Your Image:</strong> Drag and drop or select an image from your device.</li>
        <li>
          <strong>Automatic Compression:</strong> The system smartly optimizes file size while keeping quality intact.
        </li>
        <li><strong>Optional WebP Conversion:</strong> Enable WebP output for maximum performance benefits.</li>
        <li><strong>Download Optimized Image:</strong> Get your compressed image ready to use anywhere.</li>
      </ol>

      <p>
        Fully browser-based and optimized for all devices, our Compress Image tool helps you improve page load times and
        optimize storage with zero hassle.
      </p>
    </div>
  </article>
</template>
